import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createHead } from '@vueuse/head';
import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import '@/assets/css/Globals.css';
import '@/assets/css/Variables.css';
import 'leaflet/dist/leaflet.css';
import '@/index.css';
import 'vue3-circle-progress/dist/circle-progress.css';
import CircleProgress from 'vue3-circle-progress';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'bootstrap'; 

const app = createApp(App);
const head = createHead();

app.use(head);
app.use(router);
app.use(VueTelInput);
app.component('CircleProgress', CircleProgress);

app.mount('#app');
